export default __webpack_public_path__ + "static/media/Loading.4bfcdef9.svg";